
/**
 * Get test points for Level 1 tests
 */
export const getTestPoints = (testId: string): string[] => {
  console.log("Level1Service.getTestPoints called for:", testId);
  
  // Points spéciaux pour les tests de putts
  if (testId === 'putts-plat') {
    return ['G', 'H', 'I'];
  } else if (testId === 'putts-montee') {
    return ['G1', 'H1', 'I1'];
  } else if (testId === 'putts-descente') {
    return ['G2', 'H2', 'I2'];
  } else if (testId === 'putts-pente') {
    return ['G3', 'H3', 'I3'];
  } else if (testId === 'putts-pente-droite') {
    return ['G4', 'H4', 'I4'];
  }
  
  // Points spéciaux pour les tests de chipping
  if (testId === 'chipping-plat') {
    return ['G', 'H', 'I'];
  } else if (testId === 'chipping-pente-droit') {
    return ['G1', 'H1', 'I1'];
  } else if (testId === 'chipping-roulee-plat') {
    return ['G2', 'H2', 'I2'];
  }
  
  // Points spéciaux pour les tests de wedging
  if (testId === 'wedging-cercles') {
    return ['G', 'H', 'I'];
  } else if (testId === 'wedging-pente-gauche') {
    return ['G1', 'H1', 'I1'];
  } else if (testId === 'wedging-mid') {
    return ['G2', 'H2', 'I2'];
  }
  
  // Points spéciaux pour les tests bunker
  if (testId === 'bunker-court') {
    return ['G', 'H', 'I'];
  } else if (testId === 'bunker-long') {
    return ['G1', 'H1'];
  }
  
  // Points spéciaux pour les tests de fers
  if (testId === 'iron-long' || testId === 'iron-mid' || testId === 'iron-green-attack' || testId === 'iron-green-attack-100') {
    return ['G'];
  }
  
  // Points spéciaux pour les tests de bois de parcours - fairwayWood-3 utilise maintenant le point G
  if (testId === 'fairwayWood-3') {
    return ['G'];
  } else if (testId === 'fairwayWood-5') {
    return ['G'];
  }
  
  // Points spéciaux pour les tests de driver - driver-practice et driver-accuracy utilisent maintenant seulement le point G
  if (testId === 'driver-practice') {
    return ['G'];
  } else if (testId === 'driver-accuracy') {
    return ['G'];
  }
  
  // Par défaut: retourner G, H, I
  console.log("Level1Service.getTestPoints returning default G,H,I for:", testId);
  return ['G', 'H', 'I'];
};
